import React, { Component } from 'react';
import '../css/Calculator.css';
import {Button} from 'react-md';
import styles from '../css/styles.css.js';

export default class Calculator extends Component {

  constructor(props) {
    super();
    this.state = {
      val: 0.0,
      formValue: "0",
    };
    this.addChar = this.addChar.bind(this);
    this.resetCalculator = this.resetCalculator.bind(this);
    this.deleteChar = this.deleteChar.bind(this);
    this.calculate = this.calculate.bind(this);
    this.addPi = this.addPi.bind(this);
    this.percent = this.percent.bind(this);
    this.doExp = this.doExp.bind(this);
    this.doSquare = this.doSquare.bind(this);
    this.doSquareRoot = this.doSquareRoot.bind(this);
    this.doTan = this.doTan.bind(this);
    this.doCos = this.doCos.bind(this);
    this.doSin = this.doSin.bind(this);
    this.doLn = this.doLn.bind(this);
    this.changeSign = this.changeSign.bind(this);
  }

  resetCalculator(event) {
    if (event.target.value == "C") {
      this.setState({
        formValue: "0"
      })
    }
  }

  addChar(event) {
      let numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      let operators = ['/', '*', '-', '+'];
      let enteredValue;
      if (event.keyCode === undefined) {
        enteredValue = event.target.value;
      }
      else {
          if (numbers.includes(event.key) || operators.includes(event.key)) {
            enteredValue = event.key;
          }
          else {
            enteredValue = '';
          }
      }
      if (this.state.formValue == null || this.state.formValue == "0") {
        this.setState({
          formValue: enteredValue,
        });
      }
      else {
        if (event.key === 'Enter') {
          this.compute();
        }
        else {
          this.setState({
            formValue: this.state.formValue + enteredValue,
          });
        }
      }
  }

  getKeyPress(event) {
    console.log('key event', event.key);
  }

  addPi() {
    if (this.state.formValue == null || this.state.formValue == 0) {
      this.setState({
        formValue: "3.14159265359",
      });
    }
    else {
      this.setState({
        formValue: this.state.formValue + "3.14159265359",
      });
    }
  }
  
  cos() {
    /* form.display.value = Math.cos(form.display.value); */
    this.setState({
      formValue: Math.cos(this.state.formValue),
    });
  }
  
  sin() {
    /* form.display.value = Math.sin(form.display.value); */
    this.setState({
      formValue: Math.sin(this.state.formValue),
    });
  }
  
  tan() {
    /* form.display.value = Math.tan(form.display.value); */
    this.setState({
      formValue: Math.tan(this.state.formValue),
    });
  }

  doSin() {
    if(this.checkNum(this.state.formValue))
    { 
      this.sin() 
    }
  }

  doCos() {
    if(this.checkNum(this.state.formValue))
    { 
      this.cos() 
    }
  }

  doTan() {
    if(this.checkNum(this.state.formValue))
    { 
      this.tan() 
    }
  }
  
   sqrt() {
    /* form.display.value = Math.sqrt(form.display.value); */
    this.setState({
      formValue: Math.sqrt(this.state.formValue),
    });
  }
  
   ln() {
    /* form.display.value = Math.log(form.display.value); */
    this.setState({
      formValue: Math.log(this.state.formValue),
    });
  }
  
   exp() {
    /* form.display.value = Math.exp(form.display.value); */
    this.setState({
      formValue: Math.exp(this.state.formValue),
    });
  }

  doExp() {
    if(this.checkNum(this.state.formValue))
    { 
      this.exp() 
    }
  }

  doLn() {
    if(this.checkNum(this.state.formValue))
    { 
      this.ln() 
    }
  }

  doSquare() {
    if(this.checkNum(this.state.formValue))
    { 
      this.square() 
    }
  }

  doSquareRoot() {
    if(this.checkNum(this.state.formValue))
    { 
      this.sqrt() 
    }
  }
  
   deleteChar() {
    this.setState({
      formValue: this.state.formValue.toString().substring(0, this.state.formValue.length - 1),
    });
  }
   percent() {
    this.setState({
      formValue: this.state.formValue + "%"
    });
  }
  
   changeSign() {
    if(this.state.formValue.substring(0, 1) == "-") {
      this.setState({
        formValue: this.state.formValue.substring(1, this.state.formValue)
      });
    }
    else {
      this.setState({
        formValue: "-" + this.state.formValue,
      });
    }
  }
  
   compute() {
      /* form.display.value = eval(form.display.value); */
      this.setState({
        formValue: eval(this.state.formValue),
      });
    }

    calculate() {
      if(this.checkNum(this.state.formValue))
       { 
         this.compute() 
       }
    }
  
  
   square() {
    /* form.display.value = eval(form.display.value) * eval(form.display.value) */
    this.setState({
      formValue: eval(this.state.formValue) * eval(this.state.formValue),
    });
  }
  
   checkNum(str) {
    for (var i = 0; i < str.length; i++) {
      var ch = str.charAt(i);
      if (ch < "0" || ch > "9") {
        if (ch != "/" && ch != "*" && ch != "+" && ch != "-" && ch != "."
          && ch != "(" && ch!= ")" && ch != "%") {
          alert("invalid entry!")
          return false
          }
        }
      }
      return true
  }

    render() {
        return (
<form name="sci-calc">
 {/* <div style={styles.screenDiv}><textarea className="form-control" rows="4" style={styles.calciScreen} value={this.state.formValue} maxlength="25"></textarea></div> */}
 <table style={styles.calciTableStyle} cellSpacing="0" cellPadding="0">
   <tbody style={{backgroundColor: 'white'}}>
 <tr>
   <td colspan="5"><div style={styles.screenDiv}><textarea onKeyPress={this.addChar} className="form-control" value={this.state.formValue} rows="4" style={styles.calciScreen} maxlength="25"></textarea></div></td>
   </tr>
   <tr> 
     <td>
         <Button style={styles.numberButton} name="btnTop" value="C" onTouchStart={this.resetCalculator} onClick={this.resetCalculator}>AC</Button>
    </td>
     <td>
         <Button name="btnTop" value="<--" onTouchStart={this.deleteChar}  onClick={this.deleteChar}><img src="https://img.icons8.com/material-sharp/24/000000/clear-symbol.png"/></Button>
    </td>
    <td><Button style={styles.numberButton} name="btnMath" value="tan" onTouchStart={this.doTan} onClick={this.doTan}>tan</Button></td>
     <td><Button style={styles.numberButton} name="btnOpps" value="&#960;" onTouchStart={this.addPi} onClick={this.addPi}>&#960;</Button></td>
     <td><Button style={styles.operationButton} name="btnMath" value="%" onTouchStart={this.percent} onClick={this.percent}>%</Button></td>
   </tr>
     
   <tr>
     <td><Button style={styles.numberButton} name="btnMath" value="(" onTouchStart={this.addChar} onClick={this.addChar}>(</Button></td>
     <td><Button style={styles.numberButton} name="btnMath" value=")" onTouchStart={this.addChar} onClick={this.addChar}>)</Button></td>
     <td><Button style={styles.numberButton} name="btnMath" value="cos" onTouchStart={this.doCos} onClick={this.doCos}>cos</Button></td>
     <td><Button style={styles.numberButton} name="btnMath" value="sin" onTouchStart={this.doSin} onClick={this.doSin}>sin</Button></td>
     <td><Button style={styles.operationButton} name="btnMath" value="/" onTouchStart={this.addChar} onClick={this.addChar}>/</Button></td>
   </tr>
     
   <tr>
     <td><Button style={styles.numberButton} name="btnNum" value="7" onTouchStart={this.addChar} onClick={this.addChar}>7</Button></td>
     <td><Button style={styles.numberButton} name="btnNum" value="8" onTouchStart={this.addChar} onClick={this.addChar}>8</Button></td>
     <td><Button style={styles.numberButton} name="btnNum" value="9" onTouchStart={this.addChar} onClick={this.addChar}>9</Button></td>
     <td><Button style={styles.numberButton} name="btnOpps" value="exp" onTouchStart={this.doExp} onClick={this.doExp}>exp</Button></td>
     <td><Button style={styles.operationButton} name="btnMath" value="*" onTouchStart={this.addChar} onClick={this.addChar}>X</Button></td>
   </tr>
   <tr>
     <td><Button style={styles.numberButton} name="btnNum" value="4" onTouchStart={this.addChar} onClick={this.addChar}>4</Button></td>
     <td><Button style={styles.numberButton} name="btnNum" value="5" onTouchStart={this.addChar} onClick={this.addChar}>5</Button></td>
     <td><Button style={styles.numberButton} name="btnNum" value="6" onTouchStart={this.addChar} onClick={this.addChar}>6</Button></td>
     <td><Button style={styles.numberButton} name="btnOpps" value="ln" onTouchStart={this.addChar} onClick={this.doLn}>ln</Button></td>
     <td><Button style={styles.operationButton} name="btnMath" value="-" onTouchStart={this.addChar} onClick={this.addChar}>—</Button></td>
   </tr>
   <tr>
   <td>{/* <input type="button" style={styles.numberButton} name="btnNum" value="2" onClick={this.addChar}/></td> */}
     <Button style={styles.numberButton} name="btnNum" value="1" onTouchStart={this.addChar} onClick={this.addChar}>1</Button></td>
      
     <td><Button style={styles.numberButton} name="btnNum" value="2" onTouchStart={this.addChar} onClick={this.addChar}>2</Button></td>
     <td><Button style={styles.numberButton} name="btnNum" value="3" onTouchStart={this.addChar} onClick={this.addChar}>3</Button></td>
     <td><Button style={styles.numberButton} name="btnOpps" value="&radic;" onTouchStart={this.doSquareRoot} onClick={this.doSquareRoot}><h3>&radic;</h3></Button></td>
     <td><Button style={styles.operationButton} name="btnMath" value="+" onTouchStart={this.addChar} onClick={this.addChar}>+</Button></td>
   </tr>
   <tr>
     <td><Button style={styles.numberButton} name="btnMath" value="&#177;" onTouchStart={this.changeSign} onClick={this.changeSign}>&#177;</Button></td>
     <td><Button style={styles.numberButton} name="btnNum" value="0" onTouchStart={this.addChar} onClick={this.addChar}>0</Button></td>
     <td><Button style={styles.numberButton} name="btnMath" value="&#46;" onTouchStart={this.addChar} onClick={this.addChar}>.</Button></td>
     <td><Button style={styles.numberButton} name="btnOpps" value="x&#50;" onTouchStart={this.doSquare} onClick={this.doSquare}>x<sup>2</sup></Button></td>
     <td><Button style={styles.equalToButton} name="btnTop" value="=" onTouchStart={this.calculate} onClick={this.calculate}>=</Button></td>
  </tr>
  </tbody>
  </table>
  </form>   
        );
    }
}